import { create } from 'zustand';
import axios from "axios";
const API_BASE_URL = 'https://ucd-point-of-sale-prod-a8414a878924.herokuapp.com';
export const useAppointmentStore = create((set, get) => ({
    // State
    churchId: '',
    ucdChurchId: '',
    appointmentDates:  {
        data: [],
        columns: []
    },
    appointmentEvents: {
        data: [],
        columns: []
    },
    loading: false,
    error: null,
    emailStatus: null,
    noAppointmentDatesMessage: null,

    // Actions
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),

    // Fetch Appointment Dates
    fetchAppointmentDates: async (payload, isAdmin = false) => {
        try {
            set({ loading: true, error: null });

            const endpoint = isAdmin
                ? `${API_BASE_URL}/appointmentdates/findforchurchadministrator`
                : `${API_BASE_URL}/appointmentdates/findforchurchuser`;

            const response = await axios.post(endpoint, {
                church_id: payload.church_id,
                ucd_church_id: payload.ucd_church_id,
                [isAdmin ? 'church_admin_login' : 'church_user_login']: payload.password
            });

            if (response.status === 200) {
                set({
                    appointmentDates: response.data,
                    loading: false
                });
                return response.data;
            }
        } catch (error) {
            if(error.response?.status === 403){
                set({ error: "Access Denied", loading: false });
            } else if (error.response?.status === 404) {
                set({ error: "Appointment Dates Not Found for Church", loading: false });
            } else if (error.response?.status === 401) {
                console.log(error);
                set({ noAppointmentDatesMessage:error.response.data, loading: false });
            }
            return null;
        }
    },

    // Fetch Appointment Events
    fetchAppointmentEvents: async (payload, isAdmin = false) => {
        try {
            set({ loading: true, error: null });

            const endpoint = isAdmin
                ? `${API_BASE_URL}/appointmentevents/listeventsforchurchadministrator`
                : `${API_BASE_URL}/appointmentevents/listeventsforchurchuser`;

            const response = await axios.post(endpoint, {
                appointment_date_id: payload.appointment_date_id,
                ucd_church_id: payload.ucd_church_id,
                [isAdmin ? 'church_admin_login' : 'church_user_login']: payload.password
            });

            if (response.status === 200) {
                set({
                    appointmentEvents: response.data,
                    loading: false
                });

                return response.data;
            }
        } catch (error) {
            const errorMessage = error.response?.status === 403
                ? "Access Denied"
                : error.response?.status === 404
                    ? "Appointment Date Events Not Found for Appointment Date"
                    : "Error fetching appointment events";

            set({ error: errorMessage, loading: false });
            return null;
        }
    },

    // Update Appointment Event
    updateAppointmentEvent: async (payload , isAdmin) => {
        try {
            set({ loading: true, error: null });

            const response = await axios.put(`${API_BASE_URL}/appointmentevents/update`, payload);

            // Insert functionality for update on admin, remove row for client
            if (response.status === 200) {
                if(isAdmin){
                    set(state => ({
                        appointmentEvents: {
                            ...state.appointmentEvents,
                            data: state.appointmentEvents.data.map(event =>
                                event._id === payload._id ? response.data : event
                            )
                        },
                        loading: false
                    }));
                } else {
                    set(state => ({
                        appointmentEvents: {
                            ...state.appointmentEvents,
                            data: state.appointmentEvents.data.filter(event =>
                                event._id !== payload._id
                            )
                        },
                        loading: false
                    }));
                }
                return response.data;
            }
        } catch (error) {
            console.log('error??' , error);
            const errorMessage = error.response?.status === 403
                ? "You are not permitted to perform this action"
                : error.response?.status === 400
                    ? "Error Updating Appointment Event"
                    : "Error updating appointment";

            set({ error: errorMessage, loading: false });
            return null;
        }
    },

    exportEventListPDF: async (payload) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://schedule.ucdir.com/ajax/event-list-pdf.php';
        form.target = '_blank';

        for (const [key, value] of Object.entries(payload)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
        form.remove();
    },

    exportEventListCSV: async (payload) => {

        const isMobileChromeOnIOS = () => {
            const userAgent = navigator.userAgent;
            // Check for "CriOS" and iOS device identifiers
            return /CriOS/i.test(userAgent)
        };
        
        const isApple = () => {
            const userAgent = navigator.userAgent;
            return /Apple/i.test(userAgent)
        };

        if (isApple() && !isMobileChromeOnIOS()) {
            try {
                const response = await axios.post(
                    'https://schedule.ucdir.com/ajax/event-list-csv.php', {
                        appointment_date_id: payload.appointment_date_id,
                        church_admin_login: payload.church_admin_login,
                        ucd_church_id: payload.ucd_church_id,
                    },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                )

                // Create a Blob from the response data (assuming response.data contains CSV text)
                const blob = new Blob([response.data], {type: 'text/csv;charset=utf-8'});

                console.log(blob);
                const url = window.URL.createObjectURL(blob);

                // Create temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'TimeSheet.csv');
                link.style.display = 'none';
                link.target = '_self';

                document.body.appendChild(link);

                link.click();

                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

            } catch (err) {
                console.error('Download failed:', err);
            } finally {
                console.log("Your download has completed.");
            }

            } else {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = 'https://schedule.ucdir.com/ajax/event-list-csv.php';
                form.target = '_blank';

                for (const [key, value] of Object.entries(payload)) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                }
                document.body.appendChild(form);
                form.submit();
                form.remove();
            }

        },
        exportFamilyListCSV: async (payload) => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://schedule.ucdir.com/ajax/all-church-families-list.php';
            form.target = '_blank';

            console.log('exportFamilyListCSV payload: ' , payload);

            for (const [key, value] of Object.entries(payload)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                form.appendChild(input);
            }
            console.log(form);

            document.body.appendChild(form);
            form.submit();
            form.remove();
        },

            exportFamilyListDaTCSV: async (payload) => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://schedule.ucdir.com/ajax/all-church-families-by-name.php';
            form.target = '_blank';

            console.log('exportFamilyListCSV payload: ' , payload);

            for (const [key, value] of Object.entries(payload)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                form.appendChild(input);
            }

            console.log(form);

            document.body.appendChild(form);
            form.submit();
            form.remove();
        },

            sendEmailReminders: async (payload) => {
            try {
                set({ loading: true, error: null });

                const formData = new FormData();
                formData.append('appointment_date_id', payload.appointment_date_id);
                formData.append('ucd_church_id', payload.ucd_church_id);
                formData.append('church_admin_login', payload.church_admin_login);
                formData.append('subject', payload.subject);
                formData.append('message', payload.message);

                const response = await axios.post(
                    'https://schedule.ucdir.com/ajax/send-appointment-date-email-reminders.php',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                );

                if (response.status === 200) {
                    set({
                        emailStatus: response.data.delivery_report,
                        loading: false
                    });
                    return response.data;
                }
            } catch (error) {
                const errorMessage = error.response?.status === 403
                    ? "Access Denied"
                    : "Error sending email reminders";

                set({ error: errorMessage, loading: false });
                return null;
            }
        },

            clearEmailStatus: () => set({ emailStatus: null }),

            // Reset store state
            reset: () => set({
            churchId: '',
            ucdChurchId: '',
            appointmentDates: [],
            appointmentEvents: [],
            loading: false,
            error: null,
            weekendSchedulingDisabled: false
        })
    }));